export default __webpack_public_path__ + "static/media/bigGus.4a206bcb.png";